import { render } from "./TheVehicleModelDetails.vue?vue&type=template&id=541f5f63"
import script from "./TheVehicleModelDetails.vue?vue&type=script&lang=js"
export * from "./TheVehicleModelDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__